var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.001,
    height: 30,
    viewBox: "0 0 30.001 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-Regular_1_",
    d: "M419.943,1229.788h-.385v-.384a1.154,1.154,0,1,0-2.308,0v.384h-10v-.384a1.154,1.154,0,1,0-2.308,0v.384h-.385a7.316,7.316,0,0,0-7.308,7.308v13.846a7.316,7.316,0,0,0,7.308,7.307h15.385a7.316,7.316,0,0,0,7.308-7.307V1237.1A7.316,7.316,0,0,0,419.943,1229.788Zm-15.385,2.308h.385v1.923a1.154,1.154,0,1,0,2.308,0V1232.1h10v1.923a1.154,1.154,0,1,0,2.308,0V1232.1h.385a5.006,5.006,0,0,1,5,5v.384H399.558v-.384A5.006,5.006,0,0,1,404.558,1232.1Zm15.385,23.847H404.558a5.006,5.006,0,0,1-5-5v-11.154h25.385v11.154A5.006,5.006,0,0,1,419.943,1255.943Zm0-11.154a1.538,1.538,0,1,1-1.538-1.539A1.539,1.539,0,0,1,419.943,1244.789Zm-6.154,0a1.539,1.539,0,1,1-1.538-1.539A1.539,1.539,0,0,1,413.789,1244.789Zm-6.154,0a1.539,1.539,0,1,1-1.539-1.539A1.539,1.539,0,0,1,407.635,1244.789Zm12.308,6.154a1.538,1.538,0,1,1-1.538-1.539A1.539,1.539,0,0,1,419.943,1250.943Zm-6.154,0a1.539,1.539,0,1,1-1.538-1.539A1.539,1.539,0,0,1,413.789,1250.943Zm-6.154,0a1.539,1.539,0,1,1-1.539-1.539A1.539,1.539,0,0,1,407.635,1250.943Z",
    transform: "translate(-397.25 -1228.25)",
    fill: "#e23744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.46ec24282f9a5c70fb105d17940696af.svg";
export { ForwardRef as ReactComponent };